import StencilHTMLElement from "./stencil-element";

class CardLineItem extends StencilHTMLElement {
  name = "CardLineItem";
  key;
  removeButtons;
  quantityInputs;

  // Animation timing constants
  static FADE_OUT_DURATION = 300; // ms
  static TRIGGER_POPUP_DELAY = 100; // ms
  static FALLBACK_DELETE_DELAY = 100; // ms

  constructor() {
    super();
  }

  connectedCallback() {
    // console.log(`hello from CardLineItem`);
    this.key = this.getAttribute('key');
    this.removeButtons = this.querySelectorAll('[data-remove]');
    this.quantityInputs = this.querySelectorAll('[data-quantity]');
    this.init();
  }

  init() {
    this.setupEventListeners();
  }

  /**
   * Check if we're currently on the cart page
   * @returns {boolean}
   */
  isCartPage() {
    return window.location.pathname === '/cart' || 
           document.querySelector('.section-cart-items') !== null;
  }

  setupEventListeners() {
    this.removeButtons.forEach(button => {
      if (this.isCartPage()) {
        // On cart page: use capture phase to intercept before wishlist app
        button.addEventListener('click', this.handleRemove.bind(this), { capture: true });
      } else {
        // On other pages (including offcanvas): add handler in normal phase
        button.addEventListener('click', this.handleRemove.bind(this));
      }
    });
    
    this.quantityInputs.forEach(button => {
      button.addEventListener('change', this.handleQuantityChange.bind(this));
    });
  }

  /**
   * Animate and remove the line item from the DOM
   */
  animateLineItemRemoval() {
    const lineItemContainer = this.closest('.col-12');
    if (lineItemContainer) {
      // Add a fade-out animation
      lineItemContainer.style.transition = `opacity ${CardLineItem.FADE_OUT_DURATION}ms ease-out, transform ${CardLineItem.FADE_OUT_DURATION}ms ease-out`;
      lineItemContainer.style.opacity = '0';
      lineItemContainer.style.transform = 'translateX(-20px)';
      
      // Remove from DOM after animation
      setTimeout(() => {
        lineItemContainer.remove();
      }, CardLineItem.FADE_OUT_DURATION);
    } else {
      // Fallback: just hide the element
      this.style.display = 'none';
    }
  }

  handleRemove(e) {
    if (this.isCartPage()) {
      // Stop the event from reaching the wishlist app initially
      e.stopImmediatePropagation();
      e.preventDefault();
      
      // Immediately hide/remove the line item from the DOM for instant feedback
      this.animateLineItemRemoval();
      
      // Update the cart
      Stencil.Extensions.Cart.change({ id: this.key, quantity: 0 }).then(() => {
        // After cart is updated, trigger wishlist popup by clicking offcanvas button
        this.triggerWishlistPopup();
      });
      
    } else {
      // On other pages (including offcanvas)
      const button = e.target.closest('[data-remove]');
      
      // Check if this is just to trigger popup (from cart page)
      if (button && button.dataset.triggerPopupOnly) {
        // Don't prevent default - let wishlist app show popup
        // But don't call Cart.change() since it's already been called
        return;
      }
      
      setTimeout(() => {
        Stencil.Extensions.Cart.change({ id: this.key, quantity: 0 });
      }, CardLineItem.FALLBACK_DELETE_DELAY);
    }
  }

  /**
   * Trigger the wishlist popup by clicking the matching delete button in the offcanvas
   */
  triggerWishlistPopup() {
    const offcanvasCart = document.querySelector('#cart-offcanvas-content');
    if (!offcanvasCart) {
      return;
    }

    const offcanvasLineItem = offcanvasCart.querySelector(`card-line-item[key="${this.key}"]`);
    if (!offcanvasLineItem) {
      return;
    }

    const offcanvasDeleteButton = offcanvasLineItem.querySelector('[data-cart-item-remove]');
    if (!offcanvasDeleteButton) {
      return;
    }

    // Create and dispatch a click event to trigger the wishlist app
    const clickEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    
    // Set a flag so the offcanvas handler doesn't actually delete again
    offcanvasDeleteButton.dataset.triggerPopupOnly = 'true';
    
    offcanvasDeleteButton.dispatchEvent(clickEvent);
    
    // Clear the flag after a short delay
    setTimeout(() => {
      delete offcanvasDeleteButton.dataset.triggerPopupOnly;
    }, CardLineItem.TRIGGER_POPUP_DELAY);
  }

  handleQuantityChange(e) {
    Stencil.Extensions.Cart.change({ id: this.key, quantity: e.target.value });
  }
}

export default CardLineItem;